/*eslint-disable*/
import React,  { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import { Table, TableCell, TableHeader, TableLoading, Link, Button, RoundedTabs, Modal, Pagination } from 'advenio-components'
import ReEnrollmentsActions from '../../Data/Redux/ReEnrollmentsRedux'
import ReinscriptionModal from './ReinscriptionModal'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import CenterProductsActions from '../../Data/Redux/CenterProductsRedux'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  `

const TableContainer = styled.div`
  width: 100%;
  margin-top: 30px;
  padding-left: 24px;
  padding-right: 24px;
`

const PaginationContainer = styled.div`
  margin: 12px 0;
`

const TabContainer = styled.div`
  width: 400px;
  height: 40px;
  margin-bottom: 30px;
  border:  solid #CCCCCC 1px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
`
const Tab = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.active ? '#4A90E2' : ''};
  cursor: pointer;
  border-left: ${props => props.border ? ' solid #CCCCCC 1px' : ''};
`

const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 100%;
`
const Center = styled.span`
  padding: 10px 30px 10px 30px;
  background-color: #9B9B9B;
  border-radius: 20px;
  color: #FFF;
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
`
const PhotoContainer = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const NameContainer = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
const Photo = styled.div`
  background-image: ${props => props.profile_image ? 'url(' + props.profile_image + ')' : ''};
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 10%;
  border:  solid #CCCCCC 1px;
`
const Span = styled.span`
  font-size: 12px;
  color: ${props => props.active ? '#FFFFFF' : ''};
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

class Reinscriptions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeId: null,
      isOpened: false,
      parents: null,
      firstPageToRender: 1,
      lastPageToRender: 10,
      pageSelected: 1,
      queryParams: {},
      center: null,
    }
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    if (queryParams.page) {
      this.setState({ pageSelected: parseInt(queryParams.page) })
    }
    this.setState({ queryParams })
    this.props.getReEnrollments(queryParams)
    this.props.getClassrooms({'basic':true,'students':false})
    this.props.getStudyPrograms(this.props.user.center_id)
    this.props.getCenterProducts(this.props.user.center_id)
    this.props.getAllCenters()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.centers) {
      const selectedCenter = nextProps.centers.find(c => c.id === nextProps.user.center_id)
      this.setState({ center: selectedCenter })
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { getReEnrollments, goTo, match } = this.props

      const queries = { ...queryParams, page }
      getReEnrollments(queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  getChildInfo = (name,paternalLastname,maternalLastname,parent,image) => {
    let profile = ''
    let childName = name || ''
    let childMaternalLastName = maternalLastname || ''
    let childPaternalLastName = paternalLastname || ''
    if (image === '') {
      profile = '/assets/BabyAvatar.svg'
    }
    else {
      profile = image
    }
    return(
      <InfoContainer>
        <PhotoContainer>
          <Photo profile_image={profile} />
        </PhotoContainer>
        <NameContainer>
          <span style={{marginBottom:'2px'}}>{childName+' '+childPaternalLastName+' '+childMaternalLastName}</span>
          <span style={{color:'#4A4A4A'}}>{'Tutor: '+parent[0].full_name}</span>
        </NameContainer>
      </InfoContainer>
    )
  }
  
  getCompanyParent = parent => {
    const { companies } = this.props
    const [companySelected] = companies.filter(company => company.id === parent.company_id)

    return (
      <InfoContainer>
        <NameContainer>
          <span style={{ marginBottom: '2px', textOverflow: 'ellipsis' }}>{`${companySelected ? companySelected.name :'Sin Empresa'} `}</span>
          {/* <span style={{ color: '#4A4A4A' }}>{`Tutor:  ${parent.length>0 ? parent[0].full_name:''}`}</span> */}
        </NameContainer>
      </InfoContainer> 
    )
  }
  
  goTo = (e) => {
    this.props.goTo(e.currentTarget.id)
  }

  onClick = (e) => {
    let [selectedChild] = this.props.reenrollments.filter(child => child.id == e.target.id)
    this.setState({ activeId: e.target.id, isOpened: true, parents: selectedChild.parents })
  }

  onClose = () => {
    this.setState({ isOpened: false })
  }

  render() {
    const { centerProducts, studyPrograms, classrooms, meta } = this.props
    const { pageSelected, center } = this.state
    return (
      <Container>
        <TableContainer>
          <HeaderContainer>
              <RoundedTabs
              selectedTab={'/reinscriptions'}
              tabs={[
                {
                  id: '/enrollments',
                  title: 'Inscripciones',
                },
                {
                  id: '/reinscriptions',
                  title: 'Reinscripciones',
                },
                {
                  id: '/reservations',
                  title: 'Reservaciones',
                },
                {
                  id: '/disenrollments',
                  title: 'Bajas',
                },
              ]}
              onClick={this.goTo}
            />
          </HeaderContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {this.props.loading ?
            <TableLoading
                roundedCorners
                columns={[
                  {
                    id: 1,
                    header: 'Alumno y Tutor',
                    element: 'Text',
                    center: true,
                  },
                  {
                    id: 2,
                    header: '¿Quién Atendió?',
                    element: 'Text',
                    center: true,
                  },
                  {
                    id: 3,
                    header: 'Empresa',
                    element: 'Text',
                    center: true,
                  },
                  {
                    id: 4,
                    header: 'Acciones',
                    element: 'Text',
                    center: true,
                  }
                ]}
                rows={10} />
             :
          <Table data={this.props.reenrollments}
            columns={[
              {
              id: '1',
              Header: () => <TableHeader title="Alumno y Tutor" center blue />,
              accessor: ({ first_name,parents,last_name_paternal,last_name_maternal }) => ({ first_name,parents,last_name_paternal,last_name_maternal }),
              Cell:({ value: { first_name, parents,last_name_paternal,last_name_maternal} }) => <CellContainer>{this.getChildInfo(first_name,last_name_paternal,last_name_maternal,parents,'')}</CellContainer>,
              },
              {
              id: '2',
              Header: () => <TableHeader title="¿Quién Atendió?" center blue />,
              accessor: ({ assigned_to }) => ({ assigned_to }),
              Cell:({ value: { assigned_to } }) => <CellContainer><span>{assigned_to}</span></CellContainer>,
              },
              {
                id: '3',
                Header: () => <TableHeader title="Empresa" center blue />,
                accessor: ({ parents }) => ({ parents }),
                Cell: ({ value: { parents } }) =>
                  <CellContainer>{this.getCompanyParent(parents[0])}</CellContainer>,
              },
              {
              id: '4',
              Header: () => <TableHeader title="Acciones" center blue />,
              accessor: ({ first_name,id,last_name_paternal,last_name_maternal }) => ({ first_name,id,last_name_paternal,last_name_maternal }),
              Cell:({ value: { first_name, id,last_name_paternal,last_name_maternal} }) => 
              <TableCell center>
                <Button success small onClick={this.onClick}><span style={{ padding: '0px 5px' }} id={id} >Reinscribir</span></Button>
                <Button danger small id={id} ><span style={{ padding: '0px 5px' }}  id={id} >Borrar</span></Button>
              </TableCell>,
            }]}
                    />
                  }
        </TableContainer>
        <Modal
          isOpened={this.state.isOpened && centerProducts.length > 0 && studyPrograms.length > 0 && classrooms.length > 0 }
          onClose={this.onClose}
          headerTitle="Reinscribir Alumno" >
          <ReinscriptionModal
            id={this.state.activeId}
            classrooms={this.props.classrooms}
            studyPrograms={this.props.studyPrograms}
            parents={this.state.parents}
            type='reenroll'
            products={this.props.centerProducts}
            closeModal={this.onClose}
            needsCurp={center && center.requires_tax_id}
          />
        </Modal>
      </Container>
    )
  }
}

const mapStateToProps = state =>({
  reenrollments: state.re_enrollments.get.results.data,
  meta: state.re_enrollments.get.results.meta,
  links: state.re_enrollments.get.results.links,
  loading: state.re_enrollments.get.fetching,
  classrooms: state.classrooms.get.results,
  user: state.auth.user,
  studyPrograms: state.study_programs.get.results,
  centerProducts: state.center_products.get.results,
  companies: state.companies.get.results
})

const mapDispatchToProps = dispatch => ({
  getReEnrollments: query => dispatch(ReEnrollmentsActions.getRequest(query)),
  goTo: path => dispatch(push(path)),
  getAllCenters: () => dispatch(AllCentersActions.getRequest({},true)),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query,true)),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId)),
  getCenterProducts: centerId => dispatch(CenterProductsActions.getRequest(centerId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reinscriptions))



// WEBPACK FOOTER //
// ./src/Containers/Inscriptions/Reinscriptions.jsx